<template>
  <!--在线客服-->
  <div class="detailbox" v-loading="loading" id="detailbox">
    <headerbox :focus="5"></headerbox>
    <div class="fixedcolor"></div>
    <div>
      <div class="shop-top">
        <div class="left">
          <img src="../../public/statics/img/shop/logos.png" alt="" />
        </div>

        <div class="right">
          <div class="right-top">
            <div class="top-left">
              <el-input
                style="width: 8.2rem; border-radius: 0"
                placeholder="GPS"
                @keyup.enter.native="searchShop"
                v-model="keyword"
              ></el-input>
              <div class="search-btn cursor" @click="searchShop">
                <img src="../../public/statics/img/shop/search.png" alt="" />
                <p>搜索</p>
              </div>
            </div>
            <div class="top-right" @click="toshoucang(1)">
              <div class="search-btn cursor">
                <img src="../../public/statics/img/shop/car.png" alt="" />
                我的购物车
                <div class="psf">
                  <!-- <img
                    src="../../public/statics/img/shop/tip.png"
                    alt=""
                    class="ps"
                  /> -->
                  <p>{{ numss.good_count }}</p>
                </div>
              </div>
            </div>
            <div class="top-right" @click="toshoucang(2)">
              <div class="search-btn cursor">
                <img src="../../public/statics/img/shop/cang.png" alt="" />
                我的收藏
                <div class="psf">
                  <!-- <img
                    src="../../public/statics/img/shop/tip.png"
                    alt=""
                    class="ps"
                  /> -->
                  <p>{{ numss.collect_count }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="right-bottom">热门搜索:GPS</div>
        </div>
      </div>
      <div>
        <div class="content-top" style="padding: 0 12%">
          <div class="content-top-left" style="width: 30%">
            <div class="top-left-bottom">
              <div
                class="gallery-top"
                ref="swiperTop"
                style="width: 4rem; height: 4rem; margin: 0 auto"
              >
                <div class="slide-1" style="position: static">
                  <img
                    :src="slider_image[swiperIndex]"
                    style="width: 80%; position: static"
                    alt=""
                  />
                  <!-- <img> -->
                </div>
              </div>
              <div style="position: relative; width: 4rem; margin: 0 auto">
                <div
                  style="
                    width: 4rem;
                    height: 0.8rem;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                  class="gallery-thumbs"
                >
                  <div
                    class="slide cursor"
                    v-for="(item, index) in slider_image"
                    :key="index"
                    style="width: 0.8rem !important; height: 0.8rem !important"
                    @click="changeSwiper(index)"
                  >
                    <!-- <div class="imgItem"> -->
                    <img
                      style="
                        width: 0.8rem !important;
                        height: 0.8rem !important;
                        padding: 0px 3px;
                        box-sizing: border-box;
                      "
                      :src="item"
                      alt=""
                    />
                    <!-- </div> -->
                  </div>
                </div>
                <div
                  class="swiper-button-prev swiper-button-white"
                  :disabled="swiperIndex == 0"
                  @click="prev"
                  style="
                    width: 0.5rem;
                    height: 0.5rem;
                    position: absolute;
                    left: -0.4rem;
                    top: 0.6rem;
                  "
                ></div>
                <div
                  class="swiper-button-next swiper-button-white"
                  :disabled="swiperIndex == this.slider_image.length - 1"
                  @click="next"
                  style="
                    width: 0.5rem;
                    height: 0.5rem;
                    right: -0.4rem;
                    top: 0.6rem;
                  "
                ></div>
              </div>
            </div>
          </div>
          <div class="content-top-right">
            <div class="top-right-top">
              {{ shopDetail.goods_name }}
            </div>
            <div class="top-right-content">
              <div class="top-right-content-top">
                商品价格：<span>￥{{ shopDetail.price }}</span>
              </div>
              <div class="top-right-content-center">
                <div>品牌名称：{{ shopDetail.goods_brand }}</div>
                <div>商品型号：{{ shopDetail.goods_model }}</div>
                <!-- <div>订货编码：{{ shopDetail.goods_no }}</div> -->
                <div>包装规格：{{ shopDetail.goods_spec }}</div>
                <div>起订量：{{ shopDetail.start_order }}</div>
                <div></div>
              </div>
              <div class="top-right-content-bottom">
                <div
                  class="dec cursor"
                  v-for="(item1, index1) in shopDetail.productValue"
                  :key="index1"
                  :class="imgType == index1 ? 'dec1  cursor' : ' cursor'"
                  @click="qieImg(index1, item1.unique)"
                >
                  <img
                    :src="item1.image"
                    alt=""
                    style="width: 0.5rem; height: 0.5rem"
                  />
                  <span>{{ item1.suk }}</span>
                </div>
              </div>
              <div class="top-right-content-low">
                <div>
                  <el-input-number
                    v-model="nums"
                    :min="1"
                    label="描述文字"
                  ></el-input-number>
                </div>
                <div class="search-btn2" @click="addCar()">
                  <img src="../../public/statics/img/shop/car2.png" alt="" />
                  <div style="color: #fff" class="cursor">加入购物车</div>
                </div>
                <div class="buy cursor" @click="ToBuy">申请购买</div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-center">
          <div class="pdec">
            <div class="pdec-top">商品介绍</div>
          </div>
          <div class="pdec-dec">
            <div>品牌名称：{{ shopDetail.goods_brand }}</div>
            <div>包装规格：{{ shopDetail.goods_spec }}</div>
            <div>宽度：{{ shopDetail.width }}</div>
            <div>厚度：{{ shopDetail.height }}</div>
            <div>内装数量：{{ shopDetail.num }}</div>
          </div>
        </div>
        <div class="content-bottom">
          <div v-html="shopDetail.content" class="cont"></div>
        </div>
      </div>
    </div>
    <botbox></botbox>
  </div>
</template>

<script>
import headerbox from "../components/boxtop";
import botbox from "../components/botts";
import "../../public/statics/css/base.css";
import { auth, anth } from "../request/api";
import Swiper from "swiper";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getToken, setToken, removeToken } from "../request/toekn";
export default {
  name: "shop",
  data() {
    return {
      loading: true,
      page: 1,
      keyword: "",
      // keyword:'',
      swiperIndex: 0,
      popularOrder: "",
      salesOrder: "",
      priceOrder: "",
      numss: {
        good_count: 0,
        collect_count: 0,
      },
      slider_image: [
        // "https://www.swiper.com.cn/demo/images/nature-3.jpg",
        // "https://www.swiper.com.cn/demo/images/nature-9.jpg",
        // "https://www.swiper.com.cn/demo/images/nature-7.jpg",
        // "https://www.swiper.com.cn/demo/images/nature-6.jpg",
        // "https://www.swiper.com.cn/demo/images/nature-5.jpg",
      ],

      slength: 5,
      imgType: 0,
      unique: "",
      nums: "",
      checkedCities: [],
      cities: ["行业精选", "库存充足"],
      num: "",

      shopId: "",
      shopDetail: {},
      headers: {},
    };
  },
  components: {
    headerbox,
    botbox,
    swiper,
    swiperSlide,
  },
  created() {
    this.shopId = this.$route.query.id;
    console.log(this.shopId);
    this.getshopDetail();
    document.body.scrollTop = -48;
    document.documentElement.scrollTop = -48;
  },
  mounted() {
    this.headers[getToken()] = Cookies.get(getToken());
    setTimeout(() => {
      this.loading = false;
    }, 200);
    // this.$nextTick(() => {
    //   // 实现swiper双向控制
    //   const swiperTop = this.$refs.swiperTop.swiper;
    //   const swiperThumbs = this.$refs.swiperThumbs.swiper;
    //   swiperTop.controller.control = swiperThumbs;
    //   swiperThumbs.controller.control = swiperTop;
    // });
    this.getNum();
  },
  updated() {},

  methods: {
    getNum() {
      let url = "/v1/shop/my/count";
      let data = {};
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.numss.collect_count = res.data.data.collect_count;
          this.numss.good_count = res.data.data.good_count;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    changeSwiper(e) {
      this.swiperIndex = e;
    },
    prev() {
      if (this.swiperIndex > 0) {
        this.swiperIndex = this.swiperIndex - 1;
      }
    },
    next() {
      if (this.swiperIndex < this.slider_image.length - 1) {
        this.swiperIndex = this.swiperIndex + 1;
      }
    },
    getshopDetail() {
      let url = "/v1/shop/goods/show";
      let data = {
        id: this.shopId,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          // console.log(res);
          this.shopDetail = res.data.data;
          // this.slength = res.data.data.slider_image.length;
          this.slider_image = res.data.data.slider_image;
          this.unique = res.data.data.productValue[0].unique;
          this.shopDetail.price = this.shopDetail.productValue[0].price;
          this.$forceUpdate();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    qieImg(e, i) {
      this.imgType = e;
      this.unique = i;
      this.shopDetail.price = this.shopDetail.productValue[e].price;
      console.log(i);
    },
    addCar() {
      let url = "/v1/shop/my/addCart";
      let data = {
        id: this.shopId,
        product_attr_unique: this.unique,
        num: this.nums,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getNum();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    ToBuy() {
      // this.addCar();
      setTimeout(() => {
        this.$router.push({
          path: "/shoucang",
          query: {
            types: 1,
          },
        });
      }, 200);
    },
    handleAssistClick() {
      this.showAssistForm = true;
      this.showAssistBtn = false;
    },
    searchShop() {
      this.$router.push({
        path: "/shop",
        query: {
          keyword: this.keyword,
        },
      });
    },
    toshoucang(e) {
      this.$router.push({
        path: "/shoucang",
        query: {
          types: e,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.detailbox {
  img {
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
  /deep/ .el-input {
    border: 1px solid #dcdfe6;
    // border-left: none;
    // border-right: none;
    border-radius: 0px;
  }
  /deep/ .el-input {
    position: static;
  }
  /deep/ .el-input-number {
    height: 0.45rem;
    line-height: 0.45rem;
    box-sizing: content-box;
  }
  /deep/ .el-input-number {
    width: 2rem;
    line-height: 0.45rem;
  }

  /deep/ .el-input-number__decrease {
    height: calc(0.45rem);
    line-height: calc(0.45rem);
    width: 0.45rem;
    box-sizing: content-box;
    border-radius: 2px;
  }
  /deep/ .el-input-number__increase {
    height: calc(0.45rem);
    width: 0.45rem;

    line-height: calc(0.45rem);
    box-sizing: content-box;
    border-radius: 2px;
  }

  /deep/ .el-input__inner {
    height: calc(0.45rem);
    width: 2rem;
    padding: 0.1rem;
    line-height: calc(0.45rem);
    border: none;
    border-radius: 0;
  }
  .cursor {
    cursor: pointer;
  }
  .headerbox {
    z-index: 999;
  }
  .fixedcolor {
    width: 100%;
    height: 0.6rem;
    background: #2c3e50;
    position: fixed;
    top: 0;
    z-index: 998;
  }
  .shop-top {
    margin-top: 0.6rem;
    padding: 0.4rem 12%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .left {
      width: 20%;

      img {
        width: 100%;
        // height: 70px;
      }
    }
    .right {
      width: 80%;

      .right-top {
        display: flex;
        justify-content: space-between;
        .top-left {
          // /deep/ .el-input__inner {
          //   height: 51px;
          // }
          height: 0.65rem;
          line-height: 0.65rem;
          .el-input {
            display: flex;
            border: 2px solid #397ea9;
            box-sizing: content-box;
            align-items: center;
          }

          display: flex;
          justify-content: flex-start;

          .search-btn {
            width: 1.8rem;
            // padding: 0 20px;
            // box-sizing: border-box;
            // padding: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #397ea9;
            border: 2px solid #397ea9;
            opacity: 1;
            box-sizing: border-box;
            img {
              width: 0.18rem;
              height: 0.18rem;
              margin-right: 10px;
            }
            p {
              font-size: 0.18rem;
              font-family: PingFang SC;
              font-weight: bold;
              line-height: 14px;
              color: #ffffff;
              // letter-spacing: 50px;
            }
          }
        }
        .top-right {
          display: flex;
          justify-content: space-between;
          .search-btn {
            // width: 1.8rem;
            padding: 0 0.18rem;
            box-sizing: border-box;
            // padding: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            border: 2px solid #397ea9;
            opacity: 1;
            box-sizing: border-box;
            font-size: 0.16rem;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 14px;
            color: #397ea9;
            img {
              width: 0.16rem;
              height: 0.16rem;
              margin-right: 5px;
            }
            // div {
            //   position: relative;
            //   // letter-spacing: 50px;
            // }
            .psf {
              // img{
              //   margin: 0;

              // }
              display: flex;
              align-items: flex-start;
              width: 18px;
              height: 20px;
              margin-left: 2px;
              background-image: url("../../public/statics/img/shop/tip.png");
              background-size: 14px 14px;
              background-repeat: no-repeat;
              justify-content: center;
              p {
                // position: absolute;
                // right: -19px;
                // top: -8px;
                width: 10px;
                text-align: center;
                // height: 17px;
                // font-size: 0.1rem;
                font-family: PingFang SC;
                font-weight: bold;
                // line-height: 14px;
                color: #fff;
                letter-spacing: 50px;
                opacity: 1;
              }
            }
            // .ps {
            //   position: absolute;
            //   right: -30px;
            //   top: -10px;
            // }
          }
        }
      }
      .right-bottom {
        text-align: left;
      }
    }
  }
  .content-top {
    display: flex;

    justify-content: flex-start;
    // align-items: center;
    .content-top-right {
      width: calc(100% - 30% - 2rem);
      margin-left: 2rem;
      .top-right-top {
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.35rem;
        text-align: left;
        font-family: PingFang SC;
        font-weight: bold;

        color: #333333;
        // letter-spacing: 50px;
        opacity: 1;
      }
      .top-right-content {
        margin: 0.2rem 0;
        .top-right-content-top {
          width: 100%;
          height: 1rem;
          margin-bottom: 0.1rem;
          line-height: 1rem;
          text-align: left;
          padding-left: 0.3rem;
          background: rgba(153, 153, 153, 0.09);
          // opacity: 0.09;
          border-radius: 0px;

          font-size: 0.2rem;
          font-family: PingFang SC;
          font-weight: bold;

          color: #333333;
          span {
            font-size: 0.35rem;
            font-family: PingFang SC;
            font-weight: bolder;

            color: #ff9a26;

            opacity: 1;
          }
        }
        .top-right-content-center {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-left: 0.3rem;
          div {
            display: inline-block;
            width: 50%;
            height: 0.5rem;
            text-align: left;
            line-height: 0.5rem;
            font-size: 0.2rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            box-sizing: border-box;
          }
        }
        .top-right-content-bottom {
          display: flex;
          flex-wrap: wrap;
          margin: 0.2rem 0;
          .dec1 {
            display: flex;
            align-items: center;
            height: 0.5rem;
            padding: 0.05rem 0.1rem;
            margin-right: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f8f8f8;
            border: 1px solid #f53d3d;
            opacity: 1;
            border-radius: 2px;
            background: rgba(153, 153, 153, 0.09);
            font-family: PingFang SC;
            font-weight: 600;

            color: rgba(51, 51, 51, 1);
            opacity: 1;
            border-radius: 0px;
            span {
              margin-left: 0.2rem;
            }
          }
          .dec {
            display: flex;
            align-items: center;
            height: 0.5rem;
            padding: 0.05rem 0.1rem;
            margin-right: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f8f8f8;
            // border: 1px solid #f53d3d;
            opacity: 1;
            border-radius: 2px;
            background: rgba(153, 153, 153, 0.09);
            font-family: PingFang SC;
            font-weight: 600;

            color: rgba(51, 51, 51, 1);
            opacity: 1;
            border-radius: 0px;
            span {
              margin-left: 0.2rem;
            }
          }
        }
        .top-right-content-low {
          display: flex;
          justify-content: start;
          align-items: center;
          >>> .el-input {
            display: flex;

            box-sizing: content-box;
            align-items: center;
          }

          div {
            font-size: 0.25rem;
            margin-right: 0.2rem;
          }
          .buy {
            height: 0.5rem;
            line-height: 0.5rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #ff9a26;
            padding: 0 0.2rem;
            opacity: 1;
            border: 1px solid #d9d9d9;
            box-sizing: border-box;
          }
          .search-btn2 {
            display: flex;
            align-items: center;
            height: 0.5rem;
            line-height: 0.5rem;
            background-color: rgba(255, 154, 38, 1);
            padding: 0.075rem 0.2rem;
            color: #ffffff !important;
            box-sizing: border-box;
            img {
              margin-right: 5px;
              width: 0.2rem;
              height: 0.175rem;
            }
          }
        }
      }
    }
  }
  .content-center {
    padding: 0 12%;

    .pdec {
      height: 1rem;
      background: rgba(153, 153, 153, 0.09);
      opacity: 1;
      border-radius: 0px;

      .pdec-top {
        width: 2.5rem;
        text-align: center;
        height: 1rem;
        line-height: 1rem;
        background-color: #fff;
        border-top: 0.05rem solid rgba(57, 126, 169, 1);
        font-size: 0.32rem;
        font-family: PingFang SC;
        font-weight: bold;
        // line-height: 14px;
        color: #397ea9;
        // letter-spacing: 50px;
        opacity: 1;
      }
    }
    .pdec-dec {
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      align-items: center;
      border-bottom: 2px solid #999999;
      padding: 0.4rem;
      div {
        width: 20%;
        height: 0.5rem;
        line-height: 0.5rem;
        // width: 382px;
        text-align: left;
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 400;

        color: #333333;

        opacity: 1;
      }
      div:nth-child(1) {
        width: 30%;
      }
    }
  }
  .content-bottom {
    padding: 0 12%;
    // background-color: red;
    .cont {
      margin-bottom: 1rem;
      ::v-deep img {
        width: 12.5rem;
        margin: 0 auto;
        // height: 200px;
      }
      //  p {
      //     width: 100%;
      //  display: flex;
      // justify-content: flex-start;
      //     ::v-deep  b {
      //       text-align: left;
      //       text-indent: 2;
      //     }
      //     // text-align: center;

      //   }
    }

    // div {
    //   width: 100%;
    // }
    // >>> img {
    //   width: 500px;
    // }
  }
  .swiper-button-prev,
  .swiper-button-next {
    top: 70%;
  }
  .swiper-button-prev {
    left: 0rem;
    background-image: url("../../public/statics/img/shop/left.png");
  }
  .swiper-button-next {
    right: 0rem;
    background-image: url("../../public/statics/img/shop/right.png");
  }
  .gallery-thumbs {
  }
}
</style>
